import { useNavigate } from "react-router-dom";
import { ShieldX } from "lucide-react";
import { Button } from "@/components/ui/button";
import StatusScreen from "@/components/StatusScreen";
import { useSession } from "../../session/SessionContext";

const NoAccess: React.FC = () => {
  const navigate = useNavigate();
  const { user, signOut } = useSession();
  const hasHome = user?.role === "operator" || user?.organization != null;

  return (
    <StatusScreen
      icon={ShieldX}
      tone="destructive"
      title="Geen toegang"
      description="Je account heeft geen toegang tot deze organisatie."
      actions={
        hasHome ? (
          <Button onClick={() => navigate("/")}>Naar mijn organisatie</Button>
        ) : (
          <Button variant="outline" onClick={signOut}>
            Uitloggen
          </Button>
        )
      }
    />
  );
};

export default NoAccess;
